import type {
  CreativeSubject,
  CreativeBoard,
  CreativeBrand,
  CreativeItem,
  CreativeProduct,
} from "@digital-twins/shared-types";

export interface CreativeLibraryData {
  subjects: Array<CreativeSubject>;
  brands: Array<CreativeBrand>;
  products: Array<CreativeProduct>;
  boards: Array<CreativeBoard>;
  creatives: Array<CreativeItem>;
}

/**
 * The last good Library, for one user in one organization. One slot: writing
 * for another identity replaces it, and reading only matches the same identity,
 * so no organization can see another's brands. No dependencies, so the auth
 * provider can clear it on logout without loading the Library API.
 */
let slot: { key: string; data: CreativeLibraryData } | null = null;
let generation = 0;

export function creativeLibraryKey(
  userId?: string | null,
  organizationToken?: string | null,
): string | null {
  return userId ? `${userId}:${organizationToken ?? ""}` : null;
}

export function readCreativeLibrarySnapshot(
  key: string | null,
): CreativeLibraryData | null {
  return key && slot?.key === key ? slot.data : null;
}

export function creativeLibrarySnapshotGeneration(): number {
  return generation;
}

/** A request that started before the last clear never writes: logout stays final. */
export function writeCreativeLibrarySnapshot(
  key: string | null,
  data: CreativeLibraryData,
  startedAt: number,
) {
  if (key && startedAt === generation) {
    slot = { key, data };
  }
}

export function clearCreativeLibrarySnapshot() {
  slot = null;
  generation += 1;
}
